import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Cookie from "./utilities/CookieUtility";
import Home from "./pages/home";
import LoginPage from "./pages/login";
import RefreshPage from "./pages/refresh";
import Footer from "./layouts/footer";
import ProductPage from "./pages/Product";
import LivePage from "./pages/live";

function App() {
  const authorization = Cookie.get("auth");
  if (authorization) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/refresh" element={<RefreshPage />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/live" element={<LivePage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    );
  } else {
    return <LoginPage />;
  }
}

export default App;
